var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.reports }, [
    _c("div", { class: _vm.$style.title }, [
      _c(
        "div",
        { class: _vm.$style.title_icon },
        [
          _c("svg-sprite", {
            attrs: {
              name: _vm.iconName,
              size: "24",
              color: _vm.iconColor,
              type: "regular",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.title_text },
        [
          _c("div", { class: _vm.$style.text }, [
            _vm._v(
              "\n        " + _vm._s(_vm.locales("" + _vm.title)) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _vm.hasTooltip
            ? _c("tooltip", {
                class: _vm.$style.tooltip,
                attrs: {
                  content: _vm.locales("reports_title_tooltip_" + _vm.title),
                  position: "top",
                  interactive: true,
                  "with-animation": false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("svg-sprite", {
                            class: _vm.$style.icon,
                            style: {
                              "margin-right": 0,
                              "margin-left": "auto",
                              color: "#191919",
                            },
                            attrs: { name: "info", size: "24" },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1433569806
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.close },
        [
          _c("vgp-icon-button", {
            attrs: {
              size: "small",
              icon: { name: "close-1", type: "regular", size: 20 },
              colors: _vm.buttonColors,
            },
            on: { onClick: _vm.clickClose },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }